import { Injectable } from '@angular/core';
import { DataEntityVersionChanges } from '@osos/shared/api';
import { DataEntityVersionChangesPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases';
import { EntityVersionChangesParserV1Service } from '../../parsers';
import { ParserFactory } from '../../services';

@Injectable()
export class EntityVersionChangesFactoryService extends FactoryBase<
  DataEntityVersionChanges,
  DataEntityVersionChangesPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: EntityVersionChangesParserV1Service
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }
  createDataModel(
    presenter: DataEntityVersionChangesPresenterModel
  ): DataEntityVersionChanges {
    const parser = this.getParser(
      DataEntityVersionChanges,
      DataEntityVersionChangesPresenterModel,
      1
    );
    const result = parser.getDataModel(presenter);
    return result;
  }

  createPresenterModel(
    model: Partial<DataEntityVersionChanges>
  ): DataEntityVersionChangesPresenterModel {
    const parser = this.getParser(
      DataEntityVersionChanges,
      DataEntityVersionChangesPresenterModel,
      1
    );
    const result = parser?.getPresenterModel(model);
    return result;
  }
}
